import { persianIncludes, normalizePersian } from '@/components/common/SearchableSelect.vue'
import { PAGE_SEARCH_ALIASES } from '@/components/layout/pageSearchAliases'
import { PAGE_INDEX } from '@/components/layout/routeNames'
import { sectionOf, navigationAudienceAllows } from '@/components/layout/navigation'
import { schoolManagementEnabled } from '@/services/adminCapabilities'

export const SEARCH_GROUPS = {
  learners: { label: 'دانش‌آموزان', icon: 'Users', permission: 'learners.read' },
  questions: { label: 'سؤال‌ها', icon: 'FileQuestion', permission: 'questions.read_key' },
  concepts: { label: 'مباحث درسی', icon: 'BookOpen', permission: 'curriculum.read' },
  plans: { label: 'طرح‌های اشتراک', icon: 'CreditCard', permission: 'revenue.read' },
  experiments: { label: 'آزمایش‌های محصول', icon: 'FlaskConical', permission: 'experiments.read' },
}
export const adminPageIndex = can => PAGE_INDEX
  .filter(page => page.feature !== 'school_management' || schoolManagementEnabled.value)
  .filter(page => navigationAudienceAllows(page.path, can))
  .filter(page => !page.permission || (Array.isArray(page.permission) ? page.permission : [page.permission]).some(can))
  .map(page => {
    const where = sectionOf(page.path)
    return { ...page, section: [where?.group, where?.accordion].filter(Boolean).join(' › ') }
  })
export function findAdminPages(query, can, limit = 10) {
  const raw = query.trim()
  if (!raw) return []
  const named = page => persianIncludes(page.title, raw) || (page.navLabel && persianIncludes(page.navLabel, raw))
  const aliases = page => PAGE_SEARCH_ALIASES[page.path] || []
  const exact = value => normalizePersian(value) === normalizePersian(raw)
  const aliasMatch = page => aliases(page).some(alias => persianIncludes(alias, raw))
  const rank = page => exact(page.title) || (page.navLabel && exact(page.navLabel)) ? 0 : aliases(page).some(exact) ? 1 : named(page) ? 2 : aliasMatch(page) ? 3 : 4
  return adminPageIndex(can).filter(page => named(page) || aliasMatch(page) || persianIncludes(page.section, raw) || page.path.toLowerCase().includes(raw.toLowerCase())).sort((a, b) => rank(a) - rank(b)).slice(0, limit)
}
export const permittedSearchGroups = (groups, can) => groups.filter(group => SEARCH_GROUPS[group.type] && can(SEARCH_GROUPS[group.type].permission)).map(group => ({ ...group, ...SEARCH_GROUPS[group.type], items: group.items || [] }))
